const maskString = {
  apply(value, pattern = '') {
    let i = 0
    const v = value?.toString() ?? ''

    return pattern.replace(/#/g, () => v[i++]).replace(/undefined/g, '')
  },
  remove(value, pattern = '') {
    let originalValue = ''
    const v = value?.toString() ?? ''

    pattern.replace(/#/g, (_, index) => (originalValue += v[index]))

    return originalValue.replace(/undefined/g, '')
  }
}

export const cepInputMask = (value) => {
  return maskString.apply(value, '#####-###')
}

export const cepMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1')
}

export const pointsMask = (number) => {
  const roundedNumber = parseFloat(number).toFixed(2);
  const parts = roundedNumber.split('.');
  const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const formattedNumber = `${formattedInteger},${parts[1]}`;

  return formattedNumber;
}



export const maskEmails = (email, maxCharacters) => {
  const maskedEmail = email.replace(/.{2}[^@]*(?=@)/g, match => match.slice(0, 2) + '*'.repeat(match.length - 2)).replace(/(@[^.]{2})[^.]*\./g, (match, p1) => p1 + '*'.repeat(match.length - p1.length - 1) + '.');

  if (maskedEmail.length > maxCharacters) {
    const diff = maskedEmail.length - maxCharacters;
    return maskedEmail.substring(0, maskedEmail.length - diff);
  }
  return maskedEmail;
}


export const convertPoints = (value, fixed) => {
  const number = parseFloat(value);

  return number
    .toFixed(fixed)
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
